<template>
 
  <v-app style="background-color:#f8f9fb" >

  <v-dialog v-model="showFilter" persistent max-width="300">
    <v-card>
      <v-card-title>
       Mensagem
      </v-card-title>
      <v-card-text class="d-flex justify-center">
        A Diferença entre as datas não pode ser superior a {{ 
          this.dias }} dias.
      </v-card-text>
      <v-card-actions class="d-flex justify-center"> <!-- Centraliza horizontalmente -->
        <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

   
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
    <v-card>
      <v-card-title>
        Baixando arquivo...
      </v-card-title>
      <v-card-text>
        <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
        <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>


  <v-container >
    <v-col cols="12" >
      <filtro-component :opcoes="opcoes" :modos="modos" :tipos="tipos" 
      @filtrar="filterData" :title_opcao="'Situação'"
        ></filtro-component>
    </v-col>
  </v-container>


  <v-container style="background-color:#eee"  
    id="contrato"
    fluid
    tag="section">
 
    <v-row>
    
    <v-col
    cols="12">

        <base-material-card
        icon="mdi-file"
        title="Arquivos DS"
        color="red" style="margin-top:20px !important; padding-top:10px !important"
        class="px-5 py-0">

        <v-row>
          <v-col cols="12">

            <v-data-table 
            :headers="this.headers_ds"
            :items="lista_resumo"
            :items-per-page="itemsPerPage"
            hide-default-footer
            :items-per-page-text="'Registros por página'" 
            class="elevation-0 no-hover-effect"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoadingprocessos" 
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

            </v-data-table>
          </v-col>
        </v-row>  
        
        <br/>
        </base-material-card>
        <br/>
    </v-col>
  </v-row>


  <div class="d-flex justify-end" >
          <div style="width: 50px;">
          
            <span @click="download_xls" title="Baixar Arquivo CSV"  style="color:green; font-size: 32px; margin-right: 4px; cursor: pointer;">
              <i class="fas fa-file-csv"></i> <!-- Ícone de envio (avião de papel) -->
            </span>
          </div>
        </div>  

  </v-container>

</v-app> 
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DS from '../../services/ds'
import { ContentLoader } from 'vue-content-loader'
import FiltroComponent from "./components/FiltroDS.vue"; // Certifique-se de que o caminho esteja correto


  export default {
    name: 'Cobranca',

    components: {
      apexcharts: VueApexCharts,
      FiltroComponent,
      ContentLoader,
    },

    mounted() {
    },

    computed: {
     

      
    },
 
    data () {
      return {

        rules: {
            required: value => !!value || 'Obrigatório.',
          },

          expandedPanels: [0, 1], // Expande ambos os painéis: Processos (0) e Econômico (1)
          empresa: 'Todas',
          search: "",
          selectedCompany: "",
          dialog_acompanhamento: false,
          selectedType: "Todos",
          selectedOpcao: "Todas",
          selectMode: "Todos",
          produto: 'Todos',
          selectedYearFinal : '',
          selectedYear : '',
          opcoes: [],
          modos: [],
          showFilter: false,
          empresas: ["Selecione", "CEMITERIO PREVIDA", "MEMORIAL PARQUE MACEIÓ", "PARQUE DO AGRESTE", "PREVIDA", "A FLOR DO CAFÉ"],
          tipos: ["Selecione", "ASSOCIADOS_DS", "CONTRATOS_DS", "PARCELAS_DS", "FUNERAL_DS"],
          showProgress: false,
          currentGroup: null,
          isLoading : false,
          dias : 1,
          lista_resumo: [],
          headers_ds: [
            { text: 'Descrição', value: 'tipo' ,   sortable: false, },
            { text: 'Total', value: 'total' ,   sortable: false, },
          ],
        }
      
    },

    methods: {

      formatDateBR(date) {
                if (!date) return '';
                const parsedDate = new Date(date);
                const day = String(parsedDate.getDate()).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
                const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
                const year = parsedDate.getFullYear();
                return `${day}/${month}/${year}`;
            },


    filterData(valores) {
    
        this.isLoading = true;
        this.selectedType = valores.selectedType;
        this.selectedYearFinal = valores.selectedYearFinal;
        this.selectedYear = valores.selectedYear;
        this.selectedCompany = valores.selectedCompany.join(",");       
        this.dashboard();
    },

    toggleExpand(item) {
      item.expanded = !item.expanded;  // Alterna o estado de expandido
    },
    getEmpresa (status) {
            switch (status) {
            case 'PARQUE DAS FLORES': return 'orange darken-2'
            case 'CEMITERIO PREVIDA' : return 'blue lighten-1'
            case 'MEMORIAL PARQUE MACEIÓ' : return 'green lighten-1'
            case 'PARQUE DO AGRESTE' : return 'cyan lighten-1'
            case 'PREVIDA' : return 'blue lighten-1'
            case 'A FLOR DO CAFÉ' : return 'purple lighten-1'

              default: 'success'
            }
      },


      calcularPercentual(valor, meta, operacao) {
          if (operacao === "Despesa") {
            valor = -valor;
          }
          if (meta === 0) {
            return "";
          }
          const percentualAtingido = (Math.abs(valor) / Math.abs(meta)) * 100;
          return parseFloat(percentualAtingido.toFixed(2));
      },
        

 
      getFirstDayOfMonth() {
        const dataAtual = new Date();
        const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
        return this.formatDateBR(primeiroDiaDoMes);
        },



    getStatus (status) {
            switch (status) {
            case 'Ativo': return 'blue lighten-1'
            case 'Cancelado' : return 'red lighten-1'
             default: 'success'
            }
      },


      formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },


      download_xls(){
    
        if(this.selectedCompany === 'Selecione') return
         
          if(this.selectedType === 'ASSOCIADOS_DS'){
            this.showProgress = true;
              DS.associados_csv(this.selectedYear, this.selectedYearFinal, this.selectedCompany, {
                })
                .then(response => {
                  if (response.status === 200) {
                    const fileName = `associados_${Date.now()}.zip`;
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                  }
                })
                .catch(error => {
                  console.error('Erro ao baixar o arquivo Excel:', error);
                })
                .finally(() => {
                  this.showProgress = false;
                }) 
          }
          if(this.selectedType === 'CONTRATOS_DS'){

            this.showProgress = true;
              DS.contrato_csv(this.selectedYear, this.selectedYearFinal, this.selectedCompany, {
                })
                .then(response => {
                  if (response.status === 200) {
                    const fileName = `contratos_${Date.now()}.zip`;
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                  }
                })
                .catch(error => {
                  console.error('Erro ao baixar o arquivo Excel:', error);
                })
                .finally(() => {
                  this.showProgress = false;
                }) 
          }

          if(this.selectedType === 'PARCELAS_DS'){
            if (this.selectedYear !== this.selectedYearFinal) {
             // alert('A diferença entre ANO não pode ser superior a 1 ANO.')
            //  return;
            } 
              this.showProgress = true;
              DS.parcelas_csv(this.selectedYear, this.selectedYearFinal, this.selectedCompany, {
                })
                .then(response => {
                  if (response.status === 200) {
                    const fileName = `parcelas_${Date.now()}.zip`;
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                  }
                })
                .catch(error => {
                  console.error('Erro ao baixar o arquivo Excel:', error);
                })
                .finally(() => {
                  this.showProgress = false;
                }) 
          }

          if(this.selectedType === 'FUNERAL_DS'){
            if (this.selectedYear !== this.selectedYearFinal) {
              alert('A diferença entre ANO não pode ser superior a 1 ANO.')
              return;
            } 
              this.showProgress = true;
              DS.funeral_csv(this.selectedYear, this.selectedYearFinal, this.selectedCompany, {
                })
                .then(response => {
                  if (response.status === 200) {
                    const fileName = `funeral_${Date.now()}.zip`;
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                  }
                })
                .catch(error => {
                  console.error('Erro ao baixar o arquivo Excel:', error);
                })
                .finally(() => {
                  this.showProgress = false;
                }) 
          }


      },


      dashboard() {

              if(this.selectedCompany === 'Selecione') return

              if(this.selectedType === 'ASSOCIADOS_DS'){

                this.isLoadingprocessos= true;
                this.lista_resumo = [];

                DS.associados(this.selectedYear, this.selectedYearFinal, this.selectedCompany).then(response => {
                            if(response.status === 200){
                              this.lista_resumo = response.data;
                              this.isLoadingprocessos = false;
                            } 

                          }).catch(e => {    
                          }).finally(() => {
                            this.isLoadingprocessos = false;
                          });
              }

              if(this.selectedType === 'CONTRATOS_DS'){

                  this.isLoadingprocessos= true;
                  this.lista_resumo = [];

                  DS.contrato(this.selectedYear, this.selectedYearFinal, this.selectedCompany).then(response => {
                              if(response.status === 200){
                                this.lista_resumo = response.data;
                                this.isLoadingprocessos = false;
                              } 

                            }).catch(e => {    
                            }).finally(() => {
                              this.isLoadingprocessos = false;
                            });
               }

               if(this.selectedType === 'PARCELAS_DS'){

                if (this.selectedYear !== this.selectedYearFinal) {
                 // return;
                } 

                  this.isLoadingprocessos= true;
                  this.lista_resumo = [];

                  DS.parcelas(this.selectedYear, this.selectedYearFinal, this.selectedCompany).then(response => {
                              if(response.status === 200){
                                this.lista_resumo = response.data;
                                this.isLoadingprocessos = false;
                              } 

                            }).catch(e => {    
                            }).finally(() => {
                              this.isLoadingprocessos = false;
                            });
                }

                if(this.selectedType === 'FUNERAL_DS'){

                  this.isLoadingprocessos= true;
                  this.lista_resumo = [];

                  DS.funeral(this.selectedYear, this.selectedYearFinal, this.selectedCompany).then(response => {
                              if(response.status === 200){
                                this.lista_resumo = response.data;
                                this.isLoadingprocessos = false;
                              } 

                            }).catch(e => {    
                            }).finally(() => {
                              this.isLoadingprocessos = false;
                            });
                }

      },

    },
  }

  function formatDateConveter(date) {
          const year = date.getFullYear(); // Obtém o ano
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Obtém o mês (adiciona 1 e garante dois dígitos)
          const day = String(date.getDate()).padStart(2, '0'); // Obtém o dia (garante dois dígitos)
          return `${year}-${month}-${day}`;
  }

  function converteDataParaFormatoISO(dataNoFormatoBR) {
              const partes = dataNoFormatoBR.split('/');
              if (partes.length === 3) {
                const [dia, mes, ano] = partes;
                return `${ano}-${mes}-${dia}`;
              }
              return null; // Retorna null se a data estiver em um formato inválido
            }


</script>

<style scoped>

  .v-progress-circular {
    margin: 1rem;
  }

  .custom-gray-background {
    height: 80px;
  }

  
  .vuetify__expand-icon {
  display: none !important; /* Oculta os ícones de expandir */
}
  /* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
  .fill-width {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    display: flex;
  }
  
  /* Centralize horizontalmente */
  .justify-center {
    justify-content: center;
  }

  .card-loader {
    height: 100%; /* Define a altura do content-loader como 100% para preencher o v-card */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .v-data-table-header-mobile .v-data-table-header-group {
  display: none !important; /* Oculta os botões de expansão de grupo */
  }
  
  
  </style>
